import { useEffect, useState } from "react";

export const useNativePrice = (chain: any) => {
  const [price, setPrice] = useState<number>(0);

  useEffect(() => {
    const idMap: Record<any, string> = {
      Avalanche: "avalanche-2",
      Solana: "solana",
      Toncoin: "the-open-network",
    };

    const fetchPrice = async () => {
      const res = await fetch(
        `https://api.coingecko.com/api/v3/simple/price?ids=${idMap[chain]}&vs_currencies=usd`
      );
      const json = await res.json();
      setPrice(json[idMap[chain]].usd);
    };

    fetchPrice();
  }, [chain]);

  return price;
};
